export default class AssignChangeDto {
/**
 *
 * @type {string}
 * @memberof AssignChangeDto
 */
maintainRecordId?: any
/**
 *
 * @type {Array&lt;string&gt;}
 * @memberof AssignChangeDto
 */
assignBys?: any | null
}
